class ConfirmarInformacionRequest {

    patchConfirmarInformacion = (datosConsulta) => {
        return {
            "datos": {
                "celular"   : datosConsulta.celular,
                "correo"    : datosConsulta.correoEle,
                "consentimientoAdicional" : datosConsulta.terminos
            }
        }
    }

}

export default ConfirmarInformacionRequest;